// DatePickerBottomSheetModal.tsx
import {CalenderWrapper} from '@mazraeapp/react-time-calender-kit';
import moment from 'jalali-moment';
import {useEffect, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../button';

interface ISelectedDate {
  days: string;
  month: string;
  year: string;
}

interface IProps {
  title: string;
  value?: string;
  onChange: (value: string) => void;
  disablePastDates?: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const DatePickerBottomSheetModal = ({
  title,
  value,
  onChange,
  disablePastDates = false,
  isOpen,
  onClose,
}: IProps) => {
  const [selectedDate, setSelectedDate] = useState<ISelectedDate>({
    days: moment().locale('fa').format('DD'),
    month: moment().locale('fa').format('MM'),
    year: moment().locale('fa').format('YYYY'),
  });

  // keep internal state in sync with external value
  useEffect(() => {
    if (!value) return;

    const m = moment(value, 'YYYY-MM-DD');
    if (!m.isValid()) return;

    setSelectedDate({
      days: m.format('DD'),
      month: m.format('MM'),
      year: m.format('YYYY'),
    });
  }, [value]);

  const changeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDate(prev => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmitDate = () => {
    onClose();
    onChange(`${selectedDate.year}/${selectedDate.month}/${selectedDate.days}`);
  };

  // Check if selected date is less than today's date
  const isPastDate = () => {
    if (!disablePastDates) return false;

    const today = moment().startOf('day');
    const selectedMoment = moment(
      `${selectedDate.year}/${selectedDate.month}/${selectedDate.days}`,
      'jYYYY-jMM-jDD',
    ).startOf('day');

    return selectedMoment.isBefore(today, 'day');
  };

  return (
    <BottomSheet
      onDismiss={onClose}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-3 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-3xl text-gray-500 cursor-pointer icon-nameClose-remove top-6 left-6"
          onClick={onClose}
        />
        <p className="flex justify-center w-full mt-1 mb-0 text-lg text-gray-950 font-Regular">
          ویرایش اطلاعات
        </p>
        <span className="text-sm text-gray-950">
          {title} <span className="text-red-500">*</span>
        </span>
        <div className="flex justify-between w-full py-1">
          <CalenderWrapper
            startYear={moment().add(2, 'jYear').jYear()}
            buttonClassName="border-[1px] text-md w-[95px] rounded-[8px] gap-3 px-1 h-[40px] flex text-gray-500 bg-white"
            buttonGroupClassName="w-full buttonGroup-wrapper flex justify-between items-center"
            days={selectedDate.days}
            month={selectedDate.month}
            year={selectedDate.year}
            calenderType="jalali"
            onChangeCalender={changeHandler}
            buttonWrapperClassName="min-w-[90px]"
          />
        </div>

        <div className="flex items-center justify-between w-full ">
          <div className="flex justify-end w-full">
            <Button
              className="flex items-center w-full gap-2 text-white border-none outline-none bg-farm-shop-500 disabled:opacity-50 disabled:bg-gray-400 disabled:text-white disabled:cursor-not-allowed"
              onClick={handleSubmitDate}
              disabled={isPastDate()}
            >
              تایید
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default DatePickerBottomSheetModal;
